import type { Recording, TranscriptSegment } from './types'

export const recordingTitle = (recording: Recording) => recording.name.replace(/\.mp3$/i, '')

export const formatDuration = (seconds: number | null | undefined) => {
  if (!seconds || !Number.isFinite(seconds)) return '—'
  const minutes = Math.floor(seconds / 60)
  const remainder = Math.floor(seconds % 60)
  const twoDigits = (value: number) => value < 10 ? `0${value}` : String(value)
  return minutes >= 60 ? `${Math.floor(minutes / 60)}:${twoDigits(minutes % 60)}:${twoDigits(remainder)}` : `${minutes}:${twoDigits(remainder)}`
}

export const formatSize = (bytes: number) => `${(bytes / 1024 / 1024).toFixed(1)} MB`

export const availableYears = (recordings: Recording[]) => [...new Set(recordings.map(recording => recording.recordedAt?.slice(0, 4)).filter((year): year is string => Boolean(year)))].sort((a, b) => b.localeCompare(a))

export const recordingsForYear = (recordings: Recording[], year: string | undefined) => year ? recordings.filter(recording => recording.recordedAt?.startsWith(`${year}-`)) : []

export const groupByMonth = (recordings: Recording[]) => {
  const groups: Record<string, Recording[]> = {}
  recordings.forEach(recording => {
    const date = recording.recordedAt ? new Date(`${recording.recordedAt}T00:00:00Z`) : null
    const label = date ? `${date.getUTCMonth() + 1}月` : '未归档'
    if (!groups[label]) groups[label] = []
    groups[label].push(recording)
  })
  return Object.keys(groups).map(label => [label, groups[label]] as [string, Recording[]])
}

export const findSegment = (segments: TranscriptSegment[], time: number) => segments.findIndex(segment => time >= segment.startTime && time <= segment.endTime)

export const searchSegments = (segments: TranscriptSegment[], query: string) => {
  const normalized = query.trim().toLowerCase()
  return normalized ? segments.filter(segment => segment.text.toLowerCase().includes(normalized)) : []
}
